module.exports = __webpack_public_path__ + "static/media/izabella_chan.9b31d0ae.png";